import { render, staticRenderFns } from "./historicalexchangeChild.vue?vue&type=template&id=25a7baa3&scoped=true"
import script from "./historicalexchangeChild.vue?vue&type=script&lang=js"
export * from "./historicalexchangeChild.vue?vue&type=script&lang=js"
import style0 from "./historicalexchangeChild.vue?vue&type=style&index=0&id=25a7baa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a7baa3",
  null
  
)

export default component.exports